import React from 'react';

export default function AppFooter({ userEmail, gamesCount = 0, sessionsCount = 0 }) {
  return (
    <div className="relative border-t border-zinc-900 mt-12">
      <div className="max-w-[1600px] mx-auto px-6 py-4 flex items-center justify-between text-[10px] text-zinc-600 tracking-[0.2em] uppercase">
        <div className="flex items-center gap-4">
          <span>Road to Challenger · EUW · {userEmail}</span>
          <span className="text-zinc-800">·</span>
          <a href="#/privacy" className="hover:text-zinc-400 transition">Privacy</a>
          <a href="#/terms" className="hover:text-zinc-400 transition">Terms</a>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-1.5 bg-cyan-400 animate-pulse" />
          Synced · {gamesCount} games · {sessionsCount} sessions
        </div>
      </div>
    </div>
  );
}
